// extracted by mini-css-extract-plugin
module.exports = {"terms-container":"terms-conditions_terms-container__P5QCz","spinner":"terms-conditions_spinner__5K3Hw"};